import React from 'react';
import { Box, Typography } from '@mui/material';

interface StatisticsBlockProps {
    title: string;
    children: React.ReactNode;
}

export const StatisticsBlock: React.FC<StatisticsBlockProps> = ({ title, children }) => {
    return (
        <Box component="section" sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
                {title}
            </Typography>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(4, minmax(0, 1fr))' }, gap: 2 }}>
                {children}
            </Box>
        </Box>
    );
};
